var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 64.08,
    y1: 32.126,
    x2: 64.08,
    y2: 66.812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81b4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c5a94"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 65.595,
    y1: 2.11,
    x2: 65.595,
    y2: 40.61
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06b59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df2227"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 28.269,
    y1: 83.175,
    x2: 47.729,
    y2: 51.022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#388b41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cb749"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 93.461,
    y1: 86.594,
    x2: 72.731,
    y2: 36.673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4b022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fcd209"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 34.711,
    y1: 54.571,
    x2: 34.711,
    y2: 20.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 81.427,
    y1: 65.501,
    x2: 58.159,
    y2: 89.192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 81.09,
    y1: 72.316,
    x2: 84.474,
    y2: 38.896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.676853 0 0 .676853 -11.318754 -1.378687)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 46.537,
    cy: 49.495,
    cx: 64.114,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.73 57.956c0-16.356-13.26-29.615-29.614-29.615S34.5 41.6 34.5 57.956h8.46c0-11.683 9.47-21.153 21.152-21.153s21.153 9.47 21.153 21.153",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    r: 16.077,
    cy: 55.417,
    cx: 66.229,
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    r: 17.346,
    cy: 49.494,
    cx: 64.114,
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42 28.34C94.773 4.908 66.334-4.648 42.9 7a47.37 47.37 0 0 0-18.13 15.843l19.038 33C40.3 44.7 46.494 32.823 57.638 29.316c1.96-.617 4-.944 6.053-.973",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.77 22.84C10.198 44.577 16.006 74 37.744 88.583c6.725 4.508 14.493 7.217 22.563 7.87L80.2 62.6c-7.435 9.012-20.767 10.3-29.778 2.854a21.14 21.14 0 0 1-6.604-9.623",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.307 96.455c26.094 1.973 48.847-17.582 50.82-43.676a47.38 47.38 0 0 0-4.706-24.438H63.7c11.683.054 21.1 9.567 21.056 21.25A21.16 21.16 0 0 1 80.2 62.609",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.77 22.84l19.038 33c-1.4-4.747-1.1-9.837.845-14.385L25.615 21.572",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.307 96.455L80.2 62.6a21.16 21.16 0 0 1-12.269 7.192l-8.46 26.653",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42 28.34H63.7c6.437.03 12.5 2.988 16.5 8.038l27.076-6.77",
    fill: "url(#G)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoChrome);
export default __webpack_public_path__ + "static/media/LogoCHROME.9e9b7877501efa027f848bcfe42cfffa.svg";
export { ForwardRef as ReactComponent };